import { Components, Theme } from '@mui/material/styles';

export const tabConfigs: Components<Theme>['MuiTab'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.grey[700],
      fontSize: theme.typography.body2Bold.fontSize,
      fontWeight: theme.typography.body2Bold.fontWeight,
      paddingBottom: theme.spacing(1.5),
      paddingTop: theme.spacing(1.5),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      textTransform: 'none',
      transition: theme.transitions.create('color'),

      '&.Mui-selected': {
        color: theme.palette.text.primary,
        fontSize: theme.typography.body2Bold.fontSize,
        fontWeight: theme.typography.body2Bold.fontWeight,
      },
    }),
  },
};
